import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VCard,[(!_vm.withoutHeader)?_c(VToolbar,{attrs:{"flat":"","dense":""}},[_c(VToolbarTitle,[_vm._v(_vm._s(_vm.title))])],1):_vm._e(),_c(VContainer,{attrs:{"fluid":""}},[_vm._t("body")],2)],1),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }